import { EventProxy } from '../utils/eventProxy';
import { generatePluginEventListenerCallbackParams } from '../actionParams';

const componentEvents = new EventProxy();

export function onComponent(eventType, callback) {
  componentEvents.on(eventType, callback);
}

export function emitComponent(e, eventType, instance, meta, global) {
  const params = generatePluginEventListenerCallbackParams(eventType, global, meta, instance);
  if (e) {
    params.originalEvent = e;
  }
  delete params.hotArea;
  componentEvents.emit(eventType, params);
}
